import { Injectable } from "@angular/core";
import { XsAppConfigService } from "../../common/services/xs-app-config.service";
import { XsHttpApiService } from "../../common/services/xs-http-api.service";
import { CoreCommonService } from "./core-common.service";
import { PlusdCommonService } from "src/app/plusd/services/plusd-common.service";

@Injectable({
  providedIn: "root"
})
export class PluginService {
  constructor(
    public xsHttpApiService: XsHttpApiService,
    public coreCommonService: CoreCommonService,
    public xsAppConfigService: XsAppConfigService,
    public plusdCommonService: PlusdCommonService
  ) { }

  // ListarPorIdUsuarioOEFA(): any {
  //   return this.xsHttpApiService.get(
  //     "http://UsuarioREST:A12345$@200.37.65.227/wsseguridad2/OefaAdmSeg.svc",
  //     "/seguridad/ListarOpcionPorIdUsuarioIdAplicacion?idUsuario=1589&idAplicacion=182"
  //   );
  // }

  ListarPorIdUsuario(parametros: any): any {
    parametros.idEmpresa = this.xsAppConfigService.APLICACION_ID_EMPRESA;
    parametros.idSistema = this.xsAppConfigService.APLICACION_ID_SISTEMA;

    console.log("ListarPorIdUsuario: ", parametros);
    return this.xsHttpApiService.post(this.coreCommonService.APPLICATION_APP_API_HOST, "/PlugIns/listarPorIdUsuario", {
      parametros: parametros
    });
  }

  ListarPorIdUsuario2(parametros: any): any {
    console.log("ListarPorIdUsuario: ", parametros);
    return this.xsHttpApiService.post(
      this.coreCommonService.APPLICATION_APP_API_HOST,
      "/PlugIns/listarPorIdUsuario",
      parametros
    );
  }

  existeCasilla(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitudsiged/obtener-casilla",
      parametro
    );
  }

  ListarPorSistema(parametros: any): any {
    return this.xsHttpApiService.post(this.coreCommonService.APPLICATION_APP_API_HOST, "/PlugIns/listarPorIdSistema", {
      parametros: parametros
    });
  }

  CrearSesion(parametros: any): any {
    parametros.username = this.xsAppConfigService.APLICACION_USUARIO_WINDOWS;
    return this.xsHttpApiService.post(this.plusdCommonService.APPLICATION_API_HOST, "/Sesion/crearSesion", parametros);
  }

  obtenerSesion(sesion: any): any {
    return this.xsHttpApiService.post(this.plusdCommonService.APPLICATION_API_HOST , "/Sesion/obtenerPorIdSesion", sesion);
  }

  obtenerSubsector(parametro: any): any {
    return this.xsHttpApiService.post(this.plusdCommonService.APPLICATION_API_HOST, "/solicitud/obtener-subsector", parametro);
  }
}
